module.exports = __webpack_public_path__ + "img/settingsBtn.811761e7.png";